import React from "react";
import "../styles/Divulgacion.css";

const Divulgacion = () => {
  return (
    <div className="presentation-page pt-16">
      {/* Hero Section */}
      <header className="divulgacion-hero-section">
        <div className="divulgacion-hero-content">
          <div className="divulgacion-hero-container">
            {/* Hero Card */}
            <div className="divulgacion-hero-card">
              <div className="divulgacion-hero-grid">
                <div className="divulgacion-hero-left">
                  <h1 className="divulgacion-hero-title">
                    <span className="divulgacion-hero-title-gradient">Divulgación</span> Científica
                  </h1>
                </div>
                <div className="divulgacion-hero-right">
                  <p className="divulgacion-hero-description">
                    Conoce más acerca de cómo se generan los sismos, sus causas y cómo nos afectan. Material educativo y
                    recursos informativos para comprender mejor la sismología.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      {/* Enlaces de Divulgación Section */}
      <section className="divulgacion-enlaces-section">
        <div className="divulgacion-enlaces-container">
          <div className="divulgacion-enlaces-grid">
            <div className="divulgacion-enlaces-card">
              <div className="divulgacion-enlaces-content">
                <div className="divulgacion-enlaces-header">
                  <h2 className="divulgacion-enlaces-title">
                    <span className="divulgacion-enlaces-title-gradient">Recursos</span> de Divulgación
                  </h2>
                  <p className="divulgacion-enlaces-subtitle">Accede a información valiosa sobre sismos y terremotos</p>
                </div>

                <div className="divulgacion-enlaces-items">
                  <div className="divulgacion-enlaces-item">
                    <div className="divulgacion-enlaces-item-image">
                      <img
                        src={`${process.env.PUBLIC_URL}/assets/img/faq-i.png`}
                        alt="Preguntas Frecuentes"
                        className="divulgacion-enlaces-item-img"
                      />
                    </div>
                    <div className="divulgacion-enlaces-item-content">
                      <h4 className="divulgacion-enlaces-item-title">Preguntas Frecuentes</h4>
                      <p className="divulgacion-enlaces-item-description">
                        Respuestas a las preguntas frecuentes que nos hacen sobre sismos y terremotos.
                      </p>
                      <a href="/preguntas" className="divulgacion-enlaces-item-link">
                        Leer Más
                      </a>
                    </div>
                  </div>

                  <div className="divulgacion-enlaces-item">
                    <div className="divulgacion-enlaces-item-image">
                      <img
                        src={`${process.env.PUBLIC_URL}/assets/img/efectos-i.png`}
                        alt="Sismos y sus efectos"
                        className="divulgacion-enlaces-item-img"
                      />
                    </div>
                    <div className="divulgacion-enlaces-item-content">
                      <h4 className="divulgacion-enlaces-item-title">Sismos y sus efectos</h4>
                      <p className="divulgacion-enlaces-item-description">
                        Información de los fenómenos que causan los sismos y cómo nos afectan.
                      </p>
                      <a href="/efectos" className="divulgacion-enlaces-item-link">
                        Leer Más
                      </a>
                    </div>
                  </div>

                  <div className="divulgacion-enlaces-item">
                    <div className="divulgacion-enlaces-item-image">
                      <img
                        src={`${process.env.PUBLIC_URL}/assets/img/info-i.png`}
                        alt="Datos interesantes"
                        className="divulgacion-enlaces-item-img"
                      />
                    </div>
                    <div className="divulgacion-enlaces-item-content">
                      <h4 className="divulgacion-enlaces-item-title">Datos interesantes</h4>
                      <p className="divulgacion-enlaces-item-description">
                        Notas interesantes sobre los sismos y respuestas a más dudas sobre sismología.
                      </p>
                      <a href="/preguntas#mas-preguntas" className="divulgacion-enlaces-item-link">
                        Leer Más
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Material de Divulgación Section */}
      <section className="divulgacion-material-section">
        <div className="divulgacion-material-container">
          <div className="divulgacion-material-grid">
            <div className="divulgacion-material-card">
              <div className="divulgacion-material-content">
                <div className="divulgacion-material-header">
                  <h2 className="divulgacion-material-title">
                    <span className="divulgacion-material-title-gradient">Material</span> de Divulgación
                  </h2>
                  <p className="divulgacion-material-subtitle">
                    Descarga folletos informativos y material educativo sobre sismos
                  </p>
                </div>

                <div className="divulgacion-material-items">
                  <div className="divulgacion-material-item">
                    <div className="divulgacion-material-item-image">
                      <img
                        src={`${process.env.PUBLIC_URL}/assets/img/La_ciencia_terremotos.jpg`}
                        alt="La ciencia de los terremotos"
                        className="divulgacion-material-item-img"
                      />
                    </div>
                    <div className="divulgacion-material-item-content">
                      <h4 className="divulgacion-material-item-title">La ciencia de los terremotos</h4>
                      <p className="divulgacion-material-item-description">
                        Folleto informativo sobre la ciencia detrás de los terremotos y cómo se estudian.
                      </p>
                      <a
                        href="https://resnom.cicese.mx/sitio/img/La%20ciencia%20de%20la%20terremotos.pdf"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="divulgacion-material-item-button"
                      >
                        Descargar
                      </a>
                    </div>
                  </div>

                  <div className="divulgacion-material-item">
                    <div className="divulgacion-material-item-image">
                      <img
                        src={`${process.env.PUBLIC_URL}/assets/img/Que_hacer_sismos.jpg`}
                        alt="Qué hacer en caso de sismos"
                        className="divulgacion-material-item-img"
                      />
                    </div>
                    <div className="divulgacion-material-item-content">
                      <h4 className="divulgacion-material-item-title">Qué hacer en caso de sismos</h4>
                      <p className="divulgacion-material-item-description">
                        Guía práctica con recomendaciones de seguridad durante y después de un sismo.
                      </p>
                      <a
                        href="https://resnom.cicese.mx/sitio/img/Que%20hacer%20en%20caso%20de%20sismos.pdf"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="divulgacion-material-item-button"
                      >
                        Descargar
                      </a>
                    </div>
                  </div>

                  <div className="divulgacion-material-item">
                    <div className="divulgacion-material-item-image">
                      <img
                        src={`${process.env.PUBLIC_URL}/assets/img/TIPOS_DE_MAGNITUDES.jpg`}
                        alt="Tipos de magnitudes sísmicas"
                        className="divulgacion-material-item-img"
                      />
                    </div>
                    <div className="divulgacion-material-item-content">
                      <h4 className="divulgacion-material-item-title">Tipos de magnitudes sísmicas</h4>
                      <p className="divulgacion-material-item-description">
                        Explicación detallada de los diferentes tipos de magnitudes utilizadas en sismología.
                      </p>
                      <a
                        href="https://resnom.cicese.mx/sitio/img/TIPOS%20DE%20MAGNITUDES%20S%C3%8DSMICAS.pdf"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="divulgacion-material-item-button"
                      >
                        Descargar
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Divulgacion;
